export default __webpack_public_path__ + "static/media/Background_00274.09fd85c4.png";